import './Swiper.less';

export const prefix = 'bm-c-swiper';

export { default } from './Swiper';
